export type StringMap = {[key: string]: string };

export const appendOptional = <Obj extends Object>(obj: Obj): (key: keyof Obj) => StringMap | {} => {
    return (key: keyof Obj) => {
        const value = obj[key];
        return value && { [key]: value } || {};
    };
};

export const appendQueryParams = (url: URL, searchParams: URLSearchParams): URL => {
    searchParams.forEach((value, key) => url.searchParams.set(key, value));
    return url;
};
